import { StateContextType, AddressComponentType } from "../../types";

type PayloadType = {
  address_components: AddressComponentType[];
};

const setAddressFromGooglePlace = (state: StateContextType, payload: PayloadType) => {
  const { address_components } = payload;

  const address = {
    line1: "",
    line2: "",
    city: "",
    state: "",
    zip: ""
  };

  address_components.forEach((addr) => {
    switch (addr.types[0]) {
      case "street_number":
        address.line1 = addr.long_name;
        break;
      case "route":
        address.line1 = `${address.line1} ${addr.long_name}`;
        break;
      case "locality":
        address.city = addr.long_name;
        break;
      case "administrative_area_level_1":
        address.state = addr.short_name;
        break;
      case "postal_code":
        address.zip = addr.long_name;
        break;
      case "subpremise":
        address.line2 = addr.long_name;
        break;
      case "establishment":
        address.line1 = addr.long_name;
        break;
      default:
        break;
    }
  });

  return {
    ...state,
    address
  };
};

export { setAddressFromGooglePlace };
